import { Amplify } from 'aws-amplify';

/**
 * Configure Amplify with values injected at build time via Vite env vars.
 * These are populated from CDK outputs after deploying the infrastructure.
 */
export function configureAmplify() {
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID;
  const identityPoolId = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID;
  const region = import.meta.env.VITE_AWS_REGION ?? 'us-east-2';
  const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;

  if (!userPoolId || !userPoolClientId) {
    console.warn(
      '[WLL] Cognito env vars not set. Set VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_USER_POOL_CLIENT_ID.',
    );
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: userPoolId ?? '',
        userPoolClientId: userPoolClientId ?? '',
        identityPoolId: identityPoolId ?? '',
        loginWith: {
          email: true,
          oauth: cognitoDomain
            ? {
                domain: cognitoDomain,
                scopes: ['openid', 'email', 'profile'],
                redirectSignIn: [window.location.origin],
                redirectSignOut: [window.location.origin],
                responseType: 'code',
              }
            : undefined,
        },
        signUpVerificationMethod: 'link',
        userAttributes: {
          email: { required: true },
          given_name: { required: true },
          family_name: { required: true },
        },
        passwordFormat: {
          minLength: 12,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
    Storage: {
      S3: {
        bucket: import.meta.env.VITE_ASSETS_BUCKET ?? '',
        region,
      },
    },
  });
}
